import { useState, useEffect } from "react";
import { CheckIcon, CopyIcon } from "lucide-react";

export function CopyAddressButton({ address }: { address: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [copied, setCopied]);

  async function handleCopy() {
    setCopied(true);
    await navigator.clipboard.writeText(address);
  }

  return (
    <button
      className="web3kit-cursor-pointer hover:web3kit-text-foreground web3kit-text-muted-foreground"
      onClick={handleCopy}
    >
      {copied ? (
        <CheckIcon className="web3kit-size-4" />
      ) : (
        <CopyIcon className="web3kit-size-4" />
      )}
    </button>
  );
}
